import React from 'react'

const SubserviceDetailComponent = ({services}) => {
  return (
    <section className="bg-white py-12 px-4">
    <div className="container mx-auto px-4">
      <div className="flex flex-wrap -mx-4">
        {services.map((service, index) => (
          <div
            key={index}
            className="w-full md:w-1/2 lg:w-1/4 mb-8"
            data-aos="fade-up"
            data-aos-delay={index * 100}
          >
            <div className="flex flex-col justify-between items-center text-center bg-white rounded-lg py-12 px-4 transform transition hover:-translate-y-2 hover:shadow-lg border border-[#13689b] mx-2 h-full">
              <div className="flex-grow">
                {/* <div className="text-4xl text-[#13689b] mb-4">{service.icon}</div> */}
                <h3 className="text-xl font-semibold mb-2">{service.title}</h3>
                <p className="text-left text-black">{service.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
  )
}

export default SubserviceDetailComponent
